<sc-flex vertical fitHeight stretchContent class="no-field-space add-catalog-dialog">
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="erp.ui.articletype-attributegroup-editor.title"></sc-dictionary-label>
  </sc-dialog-title>

  <sc-padding>
    <form [formGroup]="formGroup">
      <sc-flex vertical stretchContent style="width: 450px;">
        <sc-dictionary-field class="name-input" [model]="name" [maxlength]="255" defaultLabel="Name"
          [required]="true" labelDictionaryKey="erp.entity.attributegroup.name"
          (dictionaryChanged)="onNameChanged($event)">
        </sc-dictionary-field>
        <sc-content-spacer vertical></sc-content-spacer>
        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="erp.entity.attributegroup.usage"></sc-dictionary-label>
          </mat-label>
          <mat-select formControlName="usage">
            @for (source of possibleUsages; track source) {
              <mat-option [value]="source">
                <sc-dictionary-label dictionaryKey="erp.entity.attributegroup.usage.{{source}}"></sc-dictionary-label>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <sc-content-spacer vertical></sc-content-spacer>
        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="erp.entity.attributegroup.sort-order"></sc-dictionary-label>
          </mat-label>
          <input matInput formControlName="sortValue">
        </mat-form-field>
        <sc-content-spacer vertical></sc-content-spacer>
        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="erp.entity.attributegroup.group-key"></sc-dictionary-label>
          </mat-label>
          <input matInput formControlName="groupKey">
        </mat-form-field>
      </sc-flex>
    </form>
  </sc-padding>

  <sc-actionbar>
    <sc-content-spacer grow></sc-content-spacer>
    <button mat-stroked-button (click)="onClose()">
      <sc-dictionary-label dictionaryKey="erp.ui.articletype-attributegroup-editor.action.cancel"></sc-dictionary-label>
    </button>
    <sc-content-spacer></sc-content-spacer>
    <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled()">
      <sc-dictionary-label dictionaryKey="erp.ui.articletype-attributegroup-editor.action.confirm"></sc-dictionary-label>
    </button>
  </sc-actionbar>
</sc-flex>
